<div class="w-[1200px]">
  <h2 class="font-semibold text-lg mb-4">{{ title$ | async }}</h2>

  <div class="flex gap-x-2 mb-2">
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [formControl]="clientForm.controls.name"
      >Наименование
    </tui-input>
    <tui-input
      class="w-4/12"
      tuiTextfieldSize="m"
      [formControl]="clientForm.controls.inn"
      >ИНН
    </tui-input>
    <tui-input-number
      class="w-4/12"
      [precision]="2"
      tuiTextfieldSize="m"
      [formControl]="clientForm.controls.discount"
      >Дисконт %
    </tui-input-number>
  </div>
  <div class="mb-2 flex gap-x-2">
    <ng-template #icon>
      <tui-svg [src]="tgIconSource"></tui-svg>
    </ng-template>
    <tui-input
      class="w-4/12"
      [tuiTextfieldIconLeft]="icon"
      tuiTextfieldSize="m"
      [tuiTextfieldLabelOutside]="false"
      [formControl]="clientForm.controls.tgBotChatId"
      >Telegram ID
    </tui-input>
    <tui-input
      class="w-8/12"
      tuiTextfieldSize="m"
      [tuiTextfieldLabelOutside]="false"
      [formControl]="clientForm.controls.comment"
      >Комментарий
    </tui-input>
  </div>
  <div class="flex gap-x-2">
    <tui-input-number
      class="w-2/12"
      tuiTextfieldSize="m"
      [formControl]="clientForm.controls.workCondition.controls.swiftSum"
      >SWIFT сумма</tui-input-number
    >
    <tui-input-number
      class="w-2/12"
      tuiTextfieldSize="m"
      [tuiTextfieldPostfix]="'%'"
      [formControl]="clientForm.controls.workCondition.controls.providerSum"
      >Перевод поставщику</tui-input-number
    >
    <app-autocomplete
      label="Документы"
      [labelOutside]="false"
      class="w-2/12"
      [itemSearch]="'itemSearch'"
      [itemText]="'text'"
      [itemValue]="'value'"
      [displayValue]="'text'"
      [items]="documentPlaces"
      [formControl]="clientForm.controls.workCondition.controls.documentPlace"
    ></app-autocomplete>
    <app-autocomplete
      label="Номенклатура"
      [labelOutside]="false"
      class="w-2/12"
      [itemSearch]="'itemSearch'"
      [itemText]="'text'"
      [itemValue]="'value'"
      [displayValue]="'text'"
      [items]="documentPlaces"
      [formControl]="
        clientForm.controls.workCondition.controls.nomenclaturePlace
      "
    ></app-autocomplete>
    <app-autocomplete
      label="Рассчет за доставку"
      [labelOutside]="false"
      class="w-2/12"
      [itemSearch]="'itemSearch'"
      [itemText]="'text'"
      [itemValue]="'value'"
      [displayValue]="'text'"
      [items]="deliveryPaymentTypes"
      [formControl]="
        clientForm.controls.workCondition.controls.deliveryPaymentType
      "
    ></app-autocomplete>
    <div class="w-2/12 flex gap-x-2 items-center">
      <app-checkbox
        [formControl]="clientForm.controls.workCondition.controls.credit"
      ></app-checkbox>
      Кредит
    </div>
  </div>
  <h3 class="font-semibold mb-2">Адреса</h3>
  <div class="mb-2 max-h-[300px] overflow-y-scroll hide-scrollbar">
    @for (
      address of clientForm.controls.addressesWithCoordinatesJson.controls;
      track index;
      let last = $last;
      let index = $index
    ) {
      <div class="flex gap-x-2 items-center mb-2">
        <div class="w-6/12" tuiGroup [collapsed]="true">
          <tui-input
            class="tui-group__inherit-item w-11/12 tui-group__auto-width-item"
            tuiTextfieldSize="m"
            [formControl]="address.controls.latLong"
            >Координаты (lat,lng)
          </tui-input>
          <button
            (click)="selectLocation$.next(index)"
            tuiIconButton
            size="m"
            icon="tuiIconMap"
          ></button>
        </div>
        <tui-input
          class="w-6/12"
          tuiTextfieldSize="m"
          [tuiTextfieldLabelOutside]="false"
          [formControl]="address.controls.address"
          >Адрес
        </tui-input>

        <div class="flex gap-x-2 w-1/12 items-center">
          <button
            appearance="accent"
            size="s"
            (click)="removeAddress(index)"
            tuiIconButton
            icon="tuiIconTrash"
          ></button>
          @if (last) {
            <button
              size="s"
              (click)="addAddress()"
              tuiIconButton
              icon="tuiIconPlus"
            ></button>
          }
        </div>
      </div>
    } @empty {
      <button size="s" tuiButton icon="tuiIconPlus" (click)="addAddress()">
        Добавить адрес
      </button>
    }
  </div>
  <h3 class="font-semibold mb-2">Контакты</h3>
  <div class="mb-2 max-h-[300px] overflow-y-scroll hide-scrollbar">
    @for (
      address of clientForm.controls.storageKeepersJson.controls;
      track index;
      let last = $last;
      let index = $index
    ) {
      <div class="flex gap-x-2 items-center mb-2">
        <tui-input
          class="w-6/12"
          tuiTextfieldSize="m"
          [tuiTextfieldLabelOutside]="false"
          [formControl]="address.controls.name"
          >Имя
        </tui-input>
        <tui-input
          [maskito]="phoneMask"
          class="w-6/12"
          tuiTextfieldSize="m"
          [tuiTextfieldLabelOutside]="false"
          [formControl]="address.controls.phone"
          >Телефон
        </tui-input>

        <div class="flex gap-x-2 w-1/12 items-center">
          <button
            appearance="accent"
            size="s"
            (click)="removeStorageKeeper(index)"
            tuiIconButton
            icon="tuiIconTrash"
          ></button>
          @if (last) {
            <button
              size="s"
              (click)="addStorageKeeper()"
              tuiIconButton
              icon="tuiIconPlus"
            ></button>
          }
        </div>
      </div>
    } @empty {
      <button
        size="s"
        tuiButton
        icon="tuiIconPlus"
        (click)="addStorageKeeper()"
      >
        Добавить контакт
      </button>
    }
  </div>
  <h3 class="font-semibold mb-2">Сотрудники</h3>
  <div class="mb-2 max-h-[300px] overflow-y-scroll hide-scrollbar">
    @for (
      member of clientForm.controls.members.controls;
      track index;
      let last = $last;
      let index = $index
    ) {
      <app-organization-member
        [last]="last"
        [memberForm]="member"
        (create)="addMember()"
        (remove)="removeMember(index)"
      ></app-organization-member>
    } @empty {
      <button size="s" tuiButton icon="tuiIconPlus" (click)="addMember()">
        Добавить сотрудника
      </button>
    }
  </div>
  <div class="flex justify-between mt-4">
    <div class="w-2/12 flex gap-x-2 items-center">
      <app-checkbox
        [formControl]="clientForm.controls.publicAccess"
      ></app-checkbox>
      Публичный доступ
    </div>
    <div>
      <button
        (click)="context.$implicit.complete()"
        size="m"
        appearance="outline"
        tuiButton
        class="mr-2"
      >
        Отмена
      </button>
      <button
        (click)="save$.next()"
        [disabled]="!clientForm.valid"
        tuiButton
        size="m"
      >
        Сохранить
      </button>
    </div>
  </div>
</div>
